// dbext:profile=staging_mcdo2019_be
import $ from "jquery";

import admin_general      from "./905-admin_general.js";
import admin_crud         from "./910-admin_crud.js";
import admin_upload_image from "./911-admin_upload_image.js";

/*

select * from 151_product_ingredient where ingredient_id not in ( select id from 150_ingredient );

*/

export default {

    init()
    {
        // categories overview?
        if ( $('.c-admin-ingredients' ).length > 0 ){
            this.init_ingredients();
        }
        // category page?
        else if ( $('.c-admin-ingredient' ).length > 0 ){
            this.init_ingredient();
        }
    },

    // ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  ingredientS  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_ingredients()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();
    },

    //⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  ingredient  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_ingredient()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // event handlers
        $('.js-form'         ).on( 'submit', this.on__form__submit()         );
        $('.js-delete-button').on( 'click' , this.on__delete_button__click() );
        $('.js-tab__delete'  ).on( 'click' , this.on__delete_tab__click()    );

        // initialize the image upload
        let image_upload = new admin_upload_image();
        image_upload.init( {
            wrapper_class : '.js-image-upload',
            post_url      : '/admin/upload/ingredient-image',
        } );

        // insert mode?
        if ( g_mode === 'insert' ){

            // published default on
            $('input[name="published"]').prop( 'checked', true );
        }

        // update mode? ⇒ make frontend reflect g_ingredient
        if ( g_mode === 'update' ){

            for ( let [ key, value ] of Object.entries( g_ingredient ) ){

                // empty value? ⇒ do nothing
                if ( value === null ){
                    continue;
                }

                // image
                if ( key === 'image' && value ){
                    image_upload.set_image( value );
                    continue;
                }

                // we need strings from now on
                if ( typeof value !== 'string' ){
                    continue;
                }

                // get the DOM element
                let de = $('[name="' + key + '"]');
                if ( de.length === 0 ){
                    continue;
                }

                // input type text
                if ( de.attr('type') === 'text' ){
                    de.val( value );
                    continue;
                }

            }
        }

    },

    on__form__submit()
    {
        return async ( e ) => {

            e.preventDefault();

            admin_general.start_spinning();

            // delete button clicked? ⇒ handle separately
            if ( $('.js-delete-button').data( 'delete-button-clicked' ) ){
                $('.js-delete-button').removeData( 'delete-button-clicked' );
                return this.on__form_delete__submit();
            }

            { // collect form data
                var ingredient_data = {};

                // get form data
                let form_data = $('.js-form').serializeArray();

                // form data → data structures
                for ( let { name, value } of form_data ){
                    ingredient_data[ name ] = value;
                }
            }

            // validate_input
            let validated = this.validate_input( ingredient_data );
            if ( ! validated ){

                // show errors
                $('.c-saved.c-saved--errors').show();
                $('.c-saved.c-saved--errors').fadeOut( 2000 );

                admin_general.stop_spinning();

                return;
            }

            // this will contain ingredient-id later
            let ingredient_id = false;

            // insert? ⇒ insert ingredient data in database and get the ingredient_id
            if ( g_mode === 'insert' ){

                // insert ingredient datacfr. 910-admin-crud.js
                let response = await
                admin_crud.POST( admin_crud.posturl( '150_ingredient', 'insert' ), {
                    data : ingredient_data,
                } );

                ingredient_id = response.data.id;
            }

            // update? ⇒ update ingredient data in database
            if ( g_mode === 'update' ){

                // get ingredient-id from g_ingredient
                ingredient_id = g_ingredient.id

                let ids = {
                    'id': ingredient_id,
                };

                let response = await
                admin_crud.POST( admin_crud.posturl( '150_ingredient', 'update' ), {
                    ids  : {
                            'id': ingredient_id,
                           },
                    data : ingredient_data,
                } );

            }

            { // handle redirect/reload

                if ( g_mode === 'insert' ){

                    let target_url = '/admin/ingredient/' + ingredient_id;

                    // redirect to the edit page of the new ingredient
                    window.location.replace( target_url );
                }
                else if ( g_mode === 'update' ){

                    // show ingredient saved
                    $('.c-saved.c-saved--ok').show();
                    $('.c-saved.c-saved--ok').fadeOut('slow');
                }
            }

            admin_general.stop_spinning();
        };
    },

    on__delete_button__click()
    {
        return ( e ) => {
            $('.js-delete-button').data( 'delete-button-clicked', true );
        };
    },

    on__delete_tab__click()
    {
        return ( e ) => {
            e.preventDefault();

            // fake that somebody clicked on the delete button on the bottom of the page
            $('.js-delete-button').click();
        };
    },

    async on__form_delete__submit()
    {

        // are your sure?
        if ( ! confirm( 'Are you sure?' ) ){
            admin_general.stop_spinning();
            return; // user is not sure...
        }

        // delete product ingredient (151_product_ingredient) records where this ingredient is used
        await this.delete_product_ingredient_records_of_ingredient( g_ingredient.id );

        // delete ingredient record
        let response = await
        admin_crud.POST( admin_crud.posturl( '150_ingredient', 'delete' ), {
            ids : {
                id : g_ingredient.id,
            },
        } );

        // redirect to ingredients overview
        window.location.replace( '/admin/ingredients' );

        return;
    },

    validate_input( ingredient_data )
    {
        $('.is-error').removeClass( 'is-error' );

        let validated = true;

        for ( let key of [ 'name_en', 'name_nl', 'name_fr',  ] ){
            if ( ! ingredient_data[key] ){
                $('[name="'+key+'"]').addClass( 'is-error' );
                validated = false;
            }
        }

        return validated;
    },

    async delete_product_ingredient_records_of_ingredient( ingredient_id )
    {
        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '151_product_ingredient', 'select_where' ), {
                'where' : {
                    'ingredient_id': ingredient_id,
                }
            } );
            return response.data;
        })();

        // delete records
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '151_product_ingredient', 'delete' ), {
                ids : {
                    product_id    : r.product_id   ,
                    ingredient_id : r.ingredient_id,
                },
            } );
        }
    },

}

